module.exports = __webpack_public_path__ + "static/media/stem-sprite-2x.bcbf3848.png";